export function pvUncertaintyDefaults(now = new Date()) {
  const endYear = now.getFullYear() - 1;
  return { enabled: false, source: "platform", startYear: endYear - 19, endYear,
    horizonYears: 25, pathCount: 2000, blockYears: 1, seed: 20260926,
    systematicPct: 0, systematicReference: "", archiveId: "", archiveMeta: null };
}

export function pvUncertaintyErrors(value, now = new Date()) {
  const errors = [];
  const integer = (key, low, high) => {
    const raw = value[key];
    const number = Number(raw);
    if (raw === "" || raw == null || typeof raw === "boolean" || !Number.isInteger(number) || number < low || number > high) errors.push(key);
  };
  integer("startYear", 1950, now.getFullYear() - 1);
  integer("endYear", 1950, now.getFullYear() - 1);
  const years = Number(value.endYear) - Number(value.startYear) + 1;
  if (years < 10 || years > 40) errors.push("period");
  if (value.source === "pvgis" && (Number(value.startYear) < 2005 || Number(value.endYear) > 2023)) errors.push("pvgisPeriod");
  integer("horizonYears", 1, 60);
  integer("pathCount", 1000, 50000);
  integer("blockYears", 1, 5);
  integer("seed", 0, 4294967295);
  const sigma = Number(value.systematicPct);
  if (value.systematicPct === "" || !Number.isFinite(sigma) || sigma < 0 || sigma > 20) errors.push("systematicPct");
  if (sigma > 0 && !value.systematicReference?.trim()) errors.push("systematicReference");
  if (!["platform", "pvgis", "upload"].includes(value.source)) errors.push("source");
  return errors;
}

export function archiveMismatchReason(meta, value, location) {
  if (!meta) return "missing";
  if (meta.source !== value.source) return "source";
  if (meta.years?.[0] !== Number(value.startYear) || meta.years?.at(-1) !== Number(value.endYear)) return "period";
  const latitude = Number(location?.lat);
  const longitude = Number(location?.lon);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return "invalidLocation";
  if (Math.abs(Number(meta.latitude) - latitude) > 0.000001 ||
    Math.abs(Number(meta.longitude) - longitude) > 0.000001) return "location";
  return null;
}

export function archiveMatches(meta, value, location) {
  return archiveMismatchReason(meta, value, location) === null;
}
